import ContactSupportRoundedIcon from '@mui/icons-material/ContactSupportRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import { Box, Button, Container, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

/**
 * InactiveLicenseView Component
 *
 * Purpose:
 * This component informs users or managers that their organization's license to
 * access the training platform is no longer active. It provides guidance on
 * next steps and a call-to-action button for contacting support.
 */
const InactiveLicenseView = () => {
  return (
    <Container
      maxWidth="md"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        display="flex"
        gap="1em"
        alignItems="center"
        justifyContent="center"
        marginBottom={4}
      >
        <ErrorOutlineRoundedIcon color="error" sx={{ fontSize: '3em' }} />
        <Typography variant="h3">License Inactive</Typography>
      </Box>
      <Typography variant="body1" textAlign="center" marginX=".25em">
        Your organization&apos;s licenses to access the training have expired.
        Please contact your administrator for assistance or reach out to us if
        you need further guidance.
      </Typography>
      <Button
        component={Link}
        to="/contact"
        variant="contained"
        color="primary"
        size="large"
        endIcon={<ContactSupportRoundedIcon />}
        sx={{
          marginY: '3em',
        }}
      >
        Contact Us
      </Button>
    </Container>
  );
};

export default InactiveLicenseView;
